import {
  ACCOUNT_TYPE_BADGE, OUTCOME_BADGE, PIPELINE_BADGE, PRIORITY_BADGE
} from '../domain';
import type { AccountType, CallOutcome, PipelineStatus } from '../types';

export function PipelineBadge({ status }: { status: PipelineStatus }) {
  const b = PIPELINE_BADGE[status];
  return <span className={`ps-badge ${b.cls}`}>{b.label}</span>;
}

export function AccountTypeBadge({ type }: { type: AccountType | 'declining' | 'growing' }) {
  const b = ACCOUNT_TYPE_BADGE[type] ?? ACCOUNT_TYPE_BADGE.existing;
  return <span className={b.cls}>{b.label}</span>;
}

export function OutcomeBadge({ outcome }: { outcome: CallOutcome | null | undefined }) {
  if (!outcome) return null;
  const b = OUTCOME_BADGE[outcome];
  if (!b) return null;
  return <span className={`outcome-badge ${b.cls}`}>{b.label}</span>;
}

export function PriorityBadge({ level }: { level: 'high' | 'medium' | 'low' }) {
  const b = PRIORITY_BADGE[level];
  return <span className={b.cls}>{b.label}</span>;
}

export function AlertBanner({ type, msg }: { type: 'overdue' | 'warn' | 'info'; msg: string }) {
  const cls = type === 'overdue' ? 'alert-overdue' : type === 'warn' ? 'alert-warn' : 'alert-info';
  const icon = type === 'overdue' ? '🚨' : type === 'warn' ? '⚠️' : 'ℹ️';
  return (
    <div className={`alert-banner ${cls}`}>
      <span style={{ fontSize: 16 }}>{icon}</span>
      <span>{msg}</span>
    </div>
  );
}
